'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var Checkbox = require('@narvar/nth-block-checkbox');
var nthHookTheme = require('@narvar/nth-hook-theme');
var MustacheNestedRender = require('@narvar/nth-bit-mustache-nested-render');
var TextLink = require('@narvar/nth-bit-text-link');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);
var MustacheNestedRender__default = /*#__PURE__*/_interopDefaultLegacy(MustacheNestedRender);
var TextLink__default = /*#__PURE__*/_interopDefaultLegacy(TextLink);

const templateLinkContext = (href, style) => {
  const ALink = ({
    children
  }) => /*#__PURE__*/React__default["default"].createElement(TextLink__default["default"], {
    key: href,
    linkStyle: {
      sDefault: {
        color: style?.color,
        fontSize: 'inherit'
      }
    },
    href: href || ''
  }, children);
  return ALink;
};
const NotificationPreferencesOptin = ({
  isLandscape,
  isChecked,
  onChange
}) => {
  const {
    linksNoneDefault
  } = nthHookTheme.useTheme();
  const {
    notificationCenterSublimeOptin
  } = nthHookTranslations.useTranslations();
  const handleCheckboxChange = event => {
    onChange(event.currentTarget.checked);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": `column-three-${isLandscape ? '7' : '12'}`,
    style: {
      gridColumn: `span ${isLandscape ? '7' : '12'}`,
      marginTop: isLandscape ? '0.8rem' : undefined,
      marginBottom: isLandscape ? undefined : '0.8rem'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "notificationPreferencesOptIn",
    onChange: handleCheckboxChange,
    checked: isChecked,
    labelTextCellStyle: {
      textAlign: 'left'
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", null, /*#__PURE__*/React__default["default"].createElement(MustacheNestedRender__default["default"], {
    template: mustache__default["default"].parse(notificationCenterSublimeOptin ?? ''),
    context: new mustache__default["default"].Context({
      termsLink: () => templateLinkContext('https://corp.narvar.com/profile-terms-of-service', linksNoneDefault),
      privacyLink: () => templateLinkContext('https://corp.narvar.com/privacy-policy#consumer-annex', linksNoneDefault)
    })
  }))));
};
var NotificationPreferencesOptin$1 = nthHookTranslations.withTranslationsProvider(NotificationPreferencesOptin, {
  translationKeys: ['notificationCenterSublimeOptin']
});

exports["default"] = NotificationPreferencesOptin$1;
